<div class="header-bar">
  <h1>Job Discount Lookup</h1>
</div>
<div class="">
  <div class="content-container" *ngIf="isLoaded">
    <div *ngFor="let lookup of discountLookup; let i = index" class="mb-2">
      <h2 *ngIf="i == 0" class="sub-header-bar">Supplier Discounts</h2>
      <h2 *ngIf="i == 1" class="sub-header-bar">Customer Discounts</h2>

      <p-table
        paginatorPosition="both"
        sortField="timeBandLabel"
        [value]="viewSet[i]"
        [lazy]="true"
        [rows]="28"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        resizableColumns="true"
        [rowsPerPageOptions]="[14, 28, 56]"
        [pageLinks]="4"
        [totalRecords]="lookup.length"
        (onLazyLoad)="onGridLazyLoad($event, i)"
        [(selection)]="selectedDiscount[i]"
        [hidden]="!isLoaded"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="timeBandLabel">Time Band</th>
            <th pSortableColumn="ratio">Ratio</th>
            <th>Percentage Reduction</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="index">
          <tr (click)="onRowClick($event, i)">
            <td style="text-align: center">{{ item.timeBandLabel }}</td>
            <td style="text-align: center">{{ item.ratio }}</td>
            <td style="text-align: center">
              <input
                pInputText
                [(ngModel)]="item.percentageReduction"
                (change)="cellEdit(item)"
                [minVal]="0"
                [maxVal]="50"
                [ngModelOptions]="{ standalone: true }"
                appendTo="body"
              />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <!-- DATATABLE DEPRECATED
      <p-dataTabl paginatorPosition="both" sortField="timeBandLabel" [value]="viewSet[i]" [lazy]="true" [rows]="28" [responsive]="true" [paginator]="true"
                   rowHover="true" resizableColumns="true" [rowsPerPageOptions]="[14,28,56]" [pageLinks]="4"
                   [totalRecords]="lookup.length" (onLazyLoad)="onGridLazyLoad($event, i)" (onRowClick)="onRowClick($event, i)"
                   [editable]="tru" [(selection)]="selectedDiscount[i]"
                   [hidden]="!isLoaded">
        <p-column field="timeBandLabel" header="Time Band" [sortable]="tru" [editable]="false" [style]="{'width': '15%'}"></p-column>
        <p-column field="ratio" header="Ratio" [sortable]="tru" [editable]="false" [style]="{'width': '15%'}"></p-column>
        <p-column field="percentageReduction" header="Percentage Reduction" [sortable]="true" [editable]="tru" [style]="{'width': '25%'}">
          <ng-template let-col let-item="rowData" pTemplate="editor">
            <input pInputText [(ngModel)]="item.percentageReduction"
                   (change)="cellEdit(item)" [minVal]="0" [maxVal]="50" intDigits
                   [ngModelOptions]="{standalone: true}" appendTo="body" />
          </ng-template>
        </p-column>
      </p-dataTable>
      --->
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
